import { navigate } from "../router";
import { Sheet } from "./ui";
import { t } from "../i18n";

// modKey is how this computer writes the key shortcuts use with letters.
export const modKey = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform) ? "⌘" : "Ctrl+";
const alt = modKey === "⌘" ? "⌥" : "Alt+";

// shortcutGroups are the shortcuts, by what they are for; the sheet and
// the help page show them.
export const shortcutGroups = (): [string, [string, string][]][] => [
  [
    t("Getting around"),
    [
      [`${modKey}K`, t("Jump to a channel, person or page")],
      [`${alt}↑ / ${alt}↓`, t("Previous or next channel")],
      [`${alt}Shift+↑ / ↓`, t("Previous or next unread channel")],
      [`${modKey}G`, t("Search")],
      ["Shift+Escape", t("Mark all channels as read")],
      [`${modKey}/`, t("Show these shortcuts")],
    ],
  ],
  [
    t("Writing"),
    [
      ["Enter", t("Send")],
      ["Shift+Enter", t("New line")],
      ["↑", t("Edit your last message, in an empty box")],
      [`${modKey}B / ${modKey}I`, t("Bold or italic")],
      [`${modKey}Shift+X`, t("Strikethrough")],
      ["@", t("Mention someone")],
      ["/", t("Run a command")],
    ],
  ],
  [
    t("In a huddle"),
    [
      [`${modKey}Shift+Space`, t("Mute or unmute")],
      ["Space", t("Hold to talk while muted")],
    ],
  ],
  [
    t("Anywhere"),
    [["Escape", t("Close a dialog or the thread")]],
  ],
];

export function ShortcutsHelp({ onClose }: { onClose: () => void }) {
  return (
    <Sheet title={t("Keyboard shortcuts")} onClose={onClose} className="page shortcuts-sheet">
      {shortcutGroups().map(([title, list]) => (
        <section key={title}>
          <h3>{title}</h3>
          <dl>
            {list.map(([keys, what]) => (
              <div key={keys}>
                <dt>
                  <kbd>{keys}</kbd>
                </dt>
                <dd>{what}</dd>
              </div>
            ))}
          </dl>
        </section>
      ))}
      <p className="shortcuts-more">
        <button
          className="link"
          onClick={() => {
            onClose();
            navigate("/help");
          }}
        >
          {t("All of Lantern's help")}
        </button>
      </p>
    </Sheet>
  );
}
